import { render, staticRenderFns } from "./AnimalDetail.vue?vue&type=template&id=5c4ac1a9&scoped=true&"
import script from "./AnimalDetail.vue?vue&type=script&lang=js&"
export * from "./AnimalDetail.vue?vue&type=script&lang=js&"
import style0 from "./AnimalDetail.vue?vue&type=style&index=0&id=5c4ac1a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4ac1a9",
  null
  
)

export default component.exports